import { Phrases } from 'libs/end-to-end/src/phrases';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import { LoggerPayload } from 'libs/end-to-end/src/isomorphic-logger';

export const tryTranslateDynamic = ({
  phrase,
  customValue,
  fallback,
  language,
  logger,
}: {
  phrase: string;
  customValue: string | null;
  fallback?: TranslatedContent;
  language: Phrases;
  logger: LoggerPayload;
}): TranslatedContent => {
  if (phrase === 'dangerousUserInput') {
    return language.dangerousUserInput({ value: customValue ?? '' });
  }

  // @ts-expect-error We are dynamically accessing the phrase
  const candidate = (language as Record<string, unknown>)[phrase];

  if (typeof candidate === 'function' && candidate.length === 0) {
    try {
      return (candidate as () => TranslatedContent)();
    } catch (error) {
      logger.error({
        message: `Error calling phrase function: ${phrase}`,
        error,
      });
    }
  }

  logger.warn({
    message: `Phrase not found or not a function: ${phrase}`,
  });

  return fallback ?? '';
};

export const getPhrasesWithoutParams = (language: Phrases): string[] => {
  return Object.keys(language)
    .filter((key) => {
      // @ts-expect-error We are dynamically accessing the phrase
      const value = (language as Record<string, unknown>)[key];
      return typeof value === 'function' && value.length === 0;
    })
    .sort();
};
